//REDUCER

import { CLEAR_QUIZ_HADTOCLEAR, EDIT_BOOSTER_FEEDBACK, SUBMIT_BOOSTER_FEEDBACK, SUBSCRIBE_BOOSTER, UNSUBSCRIBE_BOOSTER, ADD_FEEDBACK_TEXT, SHOW_QUIZ_ANSWERS, REMOVE_CHECKBOX_ANSWER, SET_CHECKBOX_ANSWER, RECIEVE_USER_QUIZ, SET_QUIZ_PAGE, /*SET_QUIZ_PAGE_KEYS,*/ CLEAR_QUIZ , SET_QUIZ_ANSWER, SET_QUIZ_RESULTS, CLEAR_QUIZ_RESULTS, RESET_QUIZ } from '../actions'
import $ from 'jquery';
import { doAnswersLookeLikeTheQuestions } from './utilities'
import ReactGA from 'react-ga'
import cloneDeep from 'lodash/cloneDeep';
import { createAction, createReducer } from '@reduxjs/toolkit'

const initialState = {
	quiz: { 	
		page: 0, 
		quiz_id: null,
		questions:null,
		answers:null, 
		results:null, 
		bestResults: null, 	
		lastResults: null, 
		lastPassedResults: null,
		randomKeys:null, 
		randomAnswersKeys:null, 
		date_submitted:null,
		attempts: null, 
		status: "notTaken",
		type: null,
		hadToClear: false,
		expires: "NA"
	  },
	preassessment: { 	
		page: 0, 
		quiz_id: null,
		questions:null,
		answers:null, 
		results:null, 
		bestResults: null, 	
		lastResults: null, 
		lastPassedResults: null,
		randomKeys:null, 
		randomAnswersKeys:null, 
		date_submitted:null,
		attempts: null, 
		status: "notTaken",
		type: null,
		hadToClear: false,
		expires: "NA"
	  },
	booster: { 
		subscribed: null,
		register_date: null,
		page: null,
		next_date: null,
		questions:null,
		answers: null,
		randomKeys:null, 
		randomAnswersKeys:null, 
		feedback: null,
		feedback_completed: null,
		all_feedback: [],
		showAnswers: null,
		type: "booster"
	 }
};


const quizzes = createReducer(initialState, (builder) => {
	builder
		.addCase(createAction(RECIEVE_USER_QUIZ), (state, action) => {

			if(action.json.module.booster !== null)
			{    		
				//var b = {...booster};
				
				let questions = action.json.module.booster.questions; 
				state.booster.randomKeys = generateKeys(questions.length);
				state.booster.randomAnswersKeys = getRandomAnswersKeys(questions);
				
				state.booster.answers = getBlankAnswers(questions);
				if(action.json.user.booster.answers != null)
				{
					state.booster.answers = action.json.user.booster.answers;
				}
				
				state.booster.page = action.json.user.booster.booster_index; 
				state.booster.register_date = action.json.user.booster.register_date;
				state.booster.next_date = action.json.user.booster.next_date;
				state.booster.all_feedback = action.json.user.booster.all_feedback;
				state.booster.subscribed = action.json.user.booster.subscribed;
				
				state.booster.feedback = action.json.user.booster.feedback;
				if(action.json.user.booster.feedback !== null && action.json.user.booster.feedback !== "")
				{
					state.booster.feedback_completed = true;
				}
		
				//Now init the quiz object that will reside in user quiz.
				state.booster.questions = action.json.module.booster.questions.map(function(item, index) 
				{	 
					return (buildQuestion(action.json.module.booster, state.booster, index) ); 
				});
				
				
			}
			
			if(action.json.module.quiz != null)
			{
				//var q = {...quiz};
				let serverQuiz = action.json.user.quiz;
				let questions = action.json.module.quiz.questions;
				
				state.quiz.type = "quiz";
				state.quiz.quiz_id = action.json.module.quiz.quiz_id;
				
				state.quiz.page =  parseInt(serverQuiz.page, 10);
				
				//This param will have a date if we are loading stored answers from the db. 
				state.quiz.date_submitted = serverQuiz.date_submitted;
				state.quiz.answers = serverQuiz.answers;

				state.quiz.expires = action.json.module.quiz.expires;

				if(parseInt(action.json.module.quiz.date_changed,10) > parseInt(serverQuiz.date_submitted,10))
				{
					state.quiz.answers = getBlankAnswers(questions);
					state.quiz.page = 0;
					state.quiz.hadToClear = true;
					
					ReactGA.event({
						category: 'User',
						action: "Quiz is newer than stored answers, uid: " + action.json.user.metadata.uid + ",   quiz id: " + action.json.module.quiz.quiz_id
					});

				}else
				{
					if(serverQuiz.answers.length === 0 )  	
					{
						state.quiz.answers = getBlankAnswers(questions);
						
					}else if(!doAnswersLookeLikeTheQuestions(questions, serverQuiz.answers))//Check to see if the answer key makes sense for the quiz.
					{
						state.quiz.answers = getBlankAnswers(questions);
						state.quiz.page = 0;
						state.quiz.hadToClear = true;
						
						ReactGA.event({
							category: 'User',
							action: "User's answers didn't match quiz questions, uid: " + action.json.user.metadata.uid + ",   quiz id: " + action.json.module.quiz.quiz_id
						});
					}
				}
				
				state.quiz.randomKeys = serverQuiz.random_keys;
				
				
				//If the random keys is either zero or just doesn't match the number of questions 
				if(serverQuiz.random_keys.length !== questions.length)  
				{
					
					if(action.json.module.quiz.random === "yes")
					{
						state.quiz.randomKeys = generateRandomKeys(questions.length);
					}else
					{
						state.quiz.randomKeys = generateKeys(questions.length);
					}
				}
				state.quiz.randomAnswersKeys = getRandomAnswersKeys(questions);

				//Now init the quiz object that will reside in user quiz.
				state.quiz.questions = action.json.module.quiz.questions.map(function(item, index) 
				{	 
					return (buildQuestion(action.json.module.quiz, state.quiz, index) ); 
				});
				
				state.quiz.results = serverQuiz.results;
				if(state.quiz.results != null)
				{
					state.quiz.results.answersRandom = rearrangeArray(state.quiz.results.answers, state.quiz.randomKeys);
				}
				state.quiz.bestResults = serverQuiz.bestResults;
				state.quiz.lastResults = serverQuiz.lastResults;
				state.quiz.lastPassedResults = serverQuiz.lastPassedResults;
				
				
			}
			
			if(action.json.module.preassessment != null)
			{
				
				//var p = {...quiz};
				let serverQuiz = action.json.user.preassessment;
				let questions = action.json.module.preassessment.questions;
				
				state.preassessment.type = "preassessment";
				state.preassessment.quiz_id = action.json.module.preassessment.quiz_id;
				
				state.preassessment.page =  parseInt(serverQuiz.page, 10);
				
				state.preassessment.date_submitted = serverQuiz.date_submitted;
				state.preassessment.answers = serverQuiz.answers;

				if(parseInt(action.json.module.preassessment.date_changed,10) > parseInt(serverQuiz.date_submitted,10))
				{
					state.preassessment.answers = getBlankAnswers(questions);
					state.preassessment.page = 0;
					state.preassessment.hadToClear = true;
					
					ReactGA.event({
						category: 'User',
						action: "Quiz is newer than stored answers, uid: " + action.json.user.metadata.uid + ",   quiz id: " + action.json.module.preassessment.quiz_id
					});

				}else
				{
					if(serverQuiz.answers.length === 0 )  	
					{
						state.preassessment.answers = getBlankAnswers(questions);
						
					}else if(!doAnswersLookeLikeTheQuestions(questions, serverQuiz.answers))//Check to see if the answer key makes sense for the quiz.
					{
						state.preassessment.answers = getBlankAnswers(questions);
						state.preassessment.page = 0;
						state.preassessment.hadToClear = true;
						
						ReactGA.event({
							category: 'User',
							action: "User's answers didn't match quiz questions, uid: " + action.json.user.metadata.uid + ",   quiz id: " + action.json.module.preassessment.quiz_id
						});
					}
				}
				
				state.preassessment.randomKeys = serverQuiz.random_keys;
				
				if(serverQuiz.random_keys.length !== questions.length )  
				{
					
					if(action.json.module.preassessment.random === "yes")
					{
						state.preassessment.randomKeys = generateRandomKeys(questions.length);
					}else
					{
						state.preassessment.randomKeys = generateKeys(questions.length);
					}
				}
				state.preassessment.randomAnswersKeys = getRandomAnswersKeys(questions);

				//Now init the quiz object that will reside in user quiz.
				state.preassessment.questions = action.json.module.preassessment.questions.map(function(item, index) 
				{	 
					return (buildQuestion(action.json.module.preassessment, state.preassessment, index) ); 
				});
				
				state.preassessment.results = serverQuiz.results;
				if(state.preassessment.results !== null)
				{
					state.preassessment.results.answersRandom = rearrangeArray(state.preassessment.results.answers, state.preassessment.randomKeys);
				}
				state.preassessment.bestResults = serverQuiz.bestResults;
				state.preassessment.lastResults = serverQuiz.lastResults;
				state.preassessment.lastPassedResults = serverQuiz.lastPassedResults;
			}
		})
		.addCase(createAction(SET_QUIZ_PAGE), (state, action) => {
			state[action.quiz_type].page = action.page;	  	
	  	})
		.addCase(createAction(SHOW_QUIZ_ANSWERS), (state, action) => {
			state[action.quiz_type].showAnswers = true;
	  	})
		.addCase(createAction(ADD_FEEDBACK_TEXT), (state, action) => {
			state[action.quiz_type].feedback = action.text;
	  	})
		.addCase(createAction(SET_QUIZ_ANSWER), (state, action) => {
			state[action.quiz_type].status = "incomplete";
    		setAnswer(state[action.quiz_type], action);
    		buildAnswer(state[action.quiz_type].questions[state[action.quiz_type].page], state[action.quiz_type], state[action.quiz_type].randomKeys[state[action.quiz_type].page]);
    	
	  	})
		.addCase(createAction(SET_CHECKBOX_ANSWER), (state, action) => {
			
			var actual_qn = state[action.quiz_type].randomKeys[action.qn];
			var _quizAnswersArray = [];
			
			if (typeof state[action.quiz_type].answers[actual_qn]  !== 'string')
			{
				//answers[qn] = ""; //TODO check if this was needed
				_quizAnswersArray = [];
			}else
			{	
				if(state[action.quiz_type].answers[actual_qn] === "")
				{
					_quizAnswersArray = [];
				}else
				{
					_quizAnswersArray = state[action.quiz_type].answers[actual_qn].split(",");
				}
			}
			
			//var inverted = invertArray(quiz.randomAnswersKeys[actual_qn])	
			_quizAnswersArray.push(String(state[action.quiz_type].randomAnswersKeys[actual_qn][action.a] + 1));
			_quizAnswersArray.sort();
			
			state[action.quiz_type].answers[actual_qn] = _quizAnswersArray.join();

			buildAnswer(state[action.quiz_type].questions[state[action.quiz_type].page], state[action.quiz_type], state[action.quiz_type].randomKeys[state[action.quiz_type].page]);
			state[action.quiz_type].status = "incomplete";

	  	})

		.addCase(createAction(REMOVE_CHECKBOX_ANSWER), (state, action) => {

			let quiz = state[action.quiz_type];

			let actual_qn = quiz.randomKeys[action.qn];
    	
			if (typeof quiz.answers[actual_qn]  !== 'string')
			{
				quiz.answers[actual_qn] = "";
			}
			
			let _quizAnswersArray = quiz.answers[actual_qn].split(",");
			//var inverted = invertArray(quiz.randomAnswersKeys[actual_qn])
			var index = _quizAnswersArray.indexOf(String(quiz.randomAnswersKeys[actual_qn][action.a] + 1));
			if (index > -1) 
			{
				_quizAnswersArray.splice(index, 1);
			}
			
			quiz.answers[actual_qn] = _quizAnswersArray.join();
	
			buildAnswer(quiz.questions[quiz.page], quiz, quiz.randomKeys[quiz.page]);    
			quiz.status = "incomplete";
	  	})

		.addCase(createAction(SUBMIT_BOOSTER_FEEDBACK), (state, action) => {

			let quiz = state[action.quiz_type];
			let feedback = {date_changed: Date.now() / 1000, feedback: quiz.feedback, uid: action.user.metadata.uid, username: action.user.metadata.userName}
	    	quiz.all_feedback.push(feedback);
	    	quiz.feedback_completed = true;
	  	})

		.addCase(createAction(EDIT_BOOSTER_FEEDBACK), (state, action) => {

			let quiz = state[action.quiz_type];
			quiz.all_feedback.map(function(item, index) 
			{	 
					if(item.uid === action.user.metadata.uid)
					{
						item.feedback = quiz.feedback;
					}
			});
	  	})

		.addCase(createAction(CLEAR_QUIZ), (state, action) => {

			let quiz = state[action.quiz_type];
			quiz.page = 0;
			quiz.answers = null;
			quiz.randomKeys = null;
			quiz.randomAnswersKeys = null;
			quiz.results = null;
			
			let questions = action.quizTemplate.questions;
			
			if(action.quizTemplate.random === "yes"){
				quiz.randomKeys = generateRandomKeys(questions.length);
			}
			else{
				quiz.randomKeys = generateKeys(questions.length);
			}
			
			quiz.randomAnswersKeys = getRandomAnswersKeys(questions);
			quiz.answers = getBlankAnswers(questions);
					
			quiz.questions = action.quizTemplate.questions.map(function(item, index){	 
				return (buildQuestion(cloneDeep(action.quizTemplate), quiz, index) ); 
			});  	
	  	})

		.addCase(createAction(CLEAR_QUIZ_RESULTS), (state, action) => {
			console.log("case CLEAR_QUIZ_RESULTS", action);
			var quiz_byId2 = getQuizById(state, action.quiz_id);
    		quiz_byId2.results = null;
	  	})

		
		.addCase(createAction(SET_QUIZ_RESULTS), (state, action) => {
			
			ReactGA.event({
				category: 'User',
				action: 'Finished Quiz'
			  });
			var quiz_byId = getQuizById(state, action.quiz_id);
			console.log(quiz_byId)
			//TODO maybe rearrange this to line up with the randomization.
			quiz_byId.results = action.results;
			quiz_byId.results.answersRandom = rearrangeArray(quiz_byId.results.answers, quiz_byId.randomKeys);
			
			quiz_byId.status = "complete";
			
			if(quiz_byId.bestResults === null || quiz_byId.bestResults.score <= action.results.score)
			{
				quiz_byId.bestResults = {};
				quiz_byId.bestResults.score = action.results.score;
				quiz_byId.bestResults.passed = action.results.passed;
				quiz_byId.bestResults.date_submitted = action.results.date_submitted;
				
			}
	
			quiz_byId.lastResults = {};
			quiz_byId.lastResults.score = action.results.score;
			quiz_byId.lastResults.passed = action.results.passed;
			quiz_byId.lastResults.date_submitted = action.results.date_submitted;
	
			if(action.results.passed == true)
			{
				quiz_byId.lastPassedResults = {};
				quiz_byId.lastPassedResults.score = action.results.score;
				quiz_byId.lastPassedResults.passed = action.results.passed;
				quiz_byId.lastPassedResults.date_submitted = action.results.date_submitted;
			}
		})

		.addCase(createAction(CLEAR_QUIZ_HADTOCLEAR), (state, action) => {
			var quiz_byId3 = getQuizById(state, action.quiz_id);
			quiz_byId3.hadToClear = false;
		})

		.addCase(createAction(SUBSCRIBE_BOOSTER), (state, action) => {
			ReactGA.event({
				category: 'User',
			action: 'Subscribed to Booster'
			});
		})

		.addCase(createAction(UNSUBSCRIBE_BOOSTER), (state, action) => {
			ReactGA.event({
				category: 'User',
			action: 'Unsubscribed to Booster'
		});
		})
		
		/*.addCase(createAction(RESET_QUIZ), (state, action) => {
			return state = initialState;
		})*/

	})

export default quizzes 


export const getAnswersSelected = (quiz) => 
{
	return quiz.answers;
}

export const getRandomKeys = (quiz) => 
{
	return quiz.randomKeys;
}

export const getResults = (quiz) => 
{
	if(quiz == null)
	{
		return null;
	}
	return quiz.results;
}

export const getQuestions = ( quiz ) => 
{
	return quiz.questions;
}

export const getQuestion = ( quiz ) => 
{
	return quiz.questions[quiz.page];
}

const setAnswer = (s, action) =>
{
	let actual_qn = s.randomKeys[action.qn];
	let _quizAnswersArray;
	//let inverted;

	switch(action.question_type)
	 {
	 	case "radio":	 		
	    	_quizAnswersArray = s.answers[actual_qn].split(",");	
	    	
	    	//inverted = invertArray(s.randomAnswersKeys[actual_qn])
	    	//console.log("setAnswers: ", s.randomAnswersKeys[actual_qn], inverted);
	    	
	    	_quizAnswersArray[action.an] = s.randomAnswersKeys[actual_qn][action.a] + 1;
	    	//_quizAnswersArray[action.an] = inverted[action.a] + 1;
	    	s.answers[actual_qn] = _quizAnswersArray.join();
	    	break;
	    	
	 	case "select":	 
	 	case "selectParagraph":	
	    	_quizAnswersArray = s.answers[actual_qn].split(",");		    	
	    	_quizAnswersArray[action.an] = action.a;
	    	s.answers[actual_qn] = _quizAnswersArray.join();
			break;
		default:
			break;
	 }
}

const buildQuestion = (quiz, state, page) => 
{

	var question = {...quiz.questions[page]};
	var actual_page = page;
	if(quiz.random === "yes")
	{
		actual_page = state.randomKeys[page];
		question = quiz.questions[actual_page];
	}
	
	return buildAnswer(question, state, actual_page);
}

const buildAnswer = (question, state, page) => 
{
	
	switch(question.type)
	 {
	 	case "radio":		 		
	 		if(question.random_answers === "yes")
	 		 {
	 			//What is stored in the answer array is 1 based not 0.
	 			var selected = getAnswerSelected(question.type, state.answers, page, 0) - 1;
	 			
	 			var inverted = invertArray(state.randomAnswersKeys[page])
				var selectedRandom = inverted[selected];
				 
				var correct = null
				if(question.correct !== null)
				{
					// eslint-disable-next-line 
					var correct =  inverted[question.correct - 1];
				}
	 			
	 			
	 			question.answerObject = {answers: rearrangeArray(question.answers, state.randomAnswersKeys[page]),
										selected: selectedRandom, 
										correct: correct};
	 		 }else
			 {
	 			question.answerObject = {answers: question.answers,
										selected: getAnswerSelected(question.type, state.answers, page, 0) - 1, 	
	 									correct : question.correct - 1};
			 }
	 		
	 		break;
	 	case "checkbox":		 			
	 		question.answerObject = question.answers.map(function(item, index){	 
				var correct = null
				if(question.correct !== null){
	 				correct = false;
					if(question.correct.includes(index + 1)){
						correct = true;
					}
				}
				return ( {answer: item,  selected: getAnswerSelected(question.type, state.answers, page, index + 1), correct: correct}); 
			 });
	 		
	 		if(question.random_answers === "yes"){
	 			question.answerObject= rearrangeArray(question.answerObject, state.randomAnswersKeys[page])
	 		}
	 		break;
	 	//These have never been randomized in the old system.	
	 	case "select":
	 	case "selectParagraph":
	 		 question.answerObject = question.answers.map(function(item, index) 
			 {	 
				var correct = null
				if(question.correct !== null)
				{
					correct = parseInt(question.correct.split(",")[index], 10);
				}
				 return ( {answer: item,  selected: getAnswerSelected(question.type, state.answers, page, index), correct: correct }); 
			 });
			 break;
		default:
			 break;
	 }
	 return question;
}



export const isFinished = ( quiz) => 
{	
	if(quiz.questions.length <= quiz.page)
	{
		return true;
	}else
	{
		return false;
	}
	
}

export const getLength = (quiz) => 
{	
	return quiz.questions.length;
	
}

export const getPage = (quiz) => {
	return quiz.page;
	
}

export const getBoosterFeedback = (quiz) => 
{
	return quiz.feedback;
}

export const getBoosterAnswers = (quiz) => 
{
	return quiz.answers;
}


export const getQuiz = (quizzes, type) => 
{
	if(Object.hasOwn(quizzes, type))
	{
		return quizzes[type];
	}

	/*
	for (var i = 0; i < quizzes.length; i++) 
	{
		var quiz = quizzes[i];
		if(quiz.type === type)
		{
			return quiz;
		}
	}
	*/
	return null;
}

export const getQuizById = (state, quiz_id) => 
{
	if(state['quiz'].quiz_id == quiz_id)
	{
		return state.quiz;
	}else if(state.preassessment.quiz_id == quiz_id)
	{
		return state.preassessment;
	}
	return null;
}


export const getStatus = (quiz) => 
{
	var status = {score: 0, text: "notTaken" };
	
	if(quiz.bestResults !== null)
	{
		status.text =  "complete";
		status.score = quiz.bestResults.score;
	}else
	{
		status.text = quiz.status;
		status.score = quiz.score;
	}
	return status;
	
}

export const getAnsweredArray = (quiz) =>
{
	var aa = [];
	for (var i = 0; i < quiz.questions.length; i++) 
	{ 
		if(!hasQuestionBeenAnswered(quiz, i))
		{
			aa[i] = false;
		}else
		{
			aa[i] = true;
		}
	}
	return aa;
}

export const wasAnsweredCorrectly = (quiz) =>
{
	if(quiz.page !== null)
	{
		if(quiz.answers[quiz.page] === quiz.questions[quiz.page].correct)
		{
			return true;
		}
	}
	return false;
}

export const haveAllQuestionsBeenAnswered = ( quiz) => 
{
	for (var i = 0; i < quiz.questions.length; i++) 
	{ 
		if(!hasQuestionBeenAnswered(quiz, i))
		{
			return false;
		}
	}
	return true;
};

export const hasQuestionBeenAnswered = (quiz, qn) =>
{
	//The answer array is not aligned with the question queue.
	var answer_qn = quiz.randomKeys[qn];
	
	
	var beenAnswered = false;
	switch(quiz.questions[qn].type)
	{
	 	case "radio":
	 	case "checkbox":
	 		beenAnswered = hasBeenAnswered(quiz.answers, answer_qn, 1);
	 		break;
	 	case "select":
	 	case "selectParagraph":
			beenAnswered = hasBeenAnswered( quiz.answers, answer_qn, quiz.questions[qn].answers.length);
			break;				
		default: 
			break;			
	 }
	return beenAnswered;
};

/**
 * qn is the question in question. n is the number of questions that should atleast be answered. 
 */
const hasBeenAnswered = ( answers, qn, n) => 
{
	if(typeof answers[qn] === 'string')
	{
		if(answers[qn] !== "")
		{
			var _quizAnswersArray = answers[qn].split(",");
			if(_quizAnswersArray.length >= n)
			{
				if(_quizAnswersArray.indexOf("0") === -1)
				{
					return true;
				}
			}
		}
	}
	return false;
};

const getAnswerSelected = (type, answers, qn, an) => {
	 
	switch(type)
	 {
	 	case "radio":	
	 	case "selectParagraph":
	 	case "select":
	 		
	 		if(typeof answers[qn] === 'string')
			{
				var _quizAnswersArray = answers[qn].split(",");
				return _quizAnswersArray[an];
			}
			return null;
				 	
	 	case "checkbox":
	 		if(typeof answers[qn] === 'string'){
				var _quizAnswersArray = answers[qn].split(",");
				if(_quizAnswersArray.includes(an.toString())){
				//if(answers[qn].indexOf(an) !== -1){
					return true;
				}
				return false;
			}
			return null;

		default:
	 		break;			
	 }
};


function getBlankAnswers(questions)
{
	//Populate answer array with blank answers. This is so if they skip all question it still scores correctly. ex: ["", "0,0", "0", ""]
	var blankAnswers = $.map(questions, function(item, index) 
	{
	 switch(item.type)
	 {
	 	case "radio":		 		
	 	case "checkbox":
	 		return "";
	 	case "select":
	 	case "selectParagraph":
		 		var answers = $.map(item.answers, function(item, index) 
		 				{
		 					return 0;
		 				});
				 return answers.join();
		default:
			break;
		 }
	});
	
	return blankAnswers.slice();
}


//Create the random answer array.  This only needs to happen onload not when props are recieved. 
function getRandomAnswersKeys(questions)
{
	var randomAnswersKeys = $.map(questions, function(item, index) 
	{
		switch(item.type)
		{
		 	case "radio":	
	 	case "checkbox":
	 	case "select":
	 		if(item.random_answers === "yes")
 			{
	 			return new Array(generateRandomKeys(item.answers.length));
 			}else
			{
 				return new Array(generateKeys(item.answers.length));
			}	 	
	 	case "selectParagraph":
		 		return new Array(generateKeys(item.answers.length));		
		default:
			break;
		}
		 

	});
	
	return randomAnswersKeys;
}


function generateRandomKeys(num)
{
	var array = [];
	for (var i = 0; i < num; i++) 
	{ 
	    array.push(i);
	}
	return shuffle(array);
}

function generateKeys(num)
{
	var array = [];
	for (var i = 0; i < num; i++) 
	{ 
	    array.push(i);
	}
	return array;
}

function shuffle(array) 
{
	  var currentIndex = array.length, temporaryValue, randomIndex;

	  // While there remain elements to shuffle...
  while (0 !== currentIndex) {

    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
	    temporaryValue = array[currentIndex];
	    array[currentIndex] = array[randomIndex];
	    array[randomIndex] = temporaryValue;
	  }

  return array;
}

function rearrangeArray(array, order)
{
	var newOrder = [];
	for (var i = 0; i < order.length; i++) 
	{
		newOrder.push(array[order[i]]);
	}
	return newOrder;
}

function invertArray(array)
{
	var newArray = [];
	for (var i = 0; i < array.length; i++) 
	{
		newArray[array[i]] = i;
	}
	return newArray;
}

